import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom' 
import GlobalStyles from './globalStyles'
import { Footer } from './components';
import Home from './pages/HomePage/Home';
import Services from './pages/Services/Services';
import FormCompra from './pages/FormCompra/FormCompra';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PaymentPending from './pages/PaymentPending/PaymentPending';
import PaymentFailure from './pages/PaymentFailure/PaymentFailure';
import Products from './pages/Products/Products';
import SignUp from './pages/SignUp/SignUp';
import ScrollToTop from './components/ScrollToTop';
import { Helmet } from 'react-helmet';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton'
import StickyCta from './components/StickyCta/StickyCta'



function App() {
  return (
    <>
      <Helmet>
        <title>Pró-Fígado - Suplemento Hepático</title>

        <meta
          name="description"
          content="Nova fórmula mais potente que auxilia na performance do seu fígado"
        />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Código externo (ex: analytics, clarity, etc.) */}
        <script>
          {`
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "vc9jckl2yl");
          `}
        </script>

      </Helmet>    
      <Router>
          <GlobalStyles />
          <ScrollToTop />
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/services' component={Services} />
            <Route path='/products' component={Products} />
            <Route path='/sign-up' component={SignUp} />
            <Route path='/form-compra' component={FormCompra} />
            <Route path='/payment-success' component={PaymentSuccess} />
            <Route path='/payment-failure' component={PaymentFailure} />
            <Route path='/payment-pending' component={PaymentPending} />

          </Switch>
          <Footer />
          <StickyCta />
          <WhatsAppButton />
      </Router>

    </>
  );
}

export default App;
